import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import { Icons } from "assets";
import classNames from "classnames";
import styles from "pages/phNewPendingTasks/style.module.scss";
import React, { useEffect, useState } from "react";
import PaginationComponent from "shared/components/pagination";
import RangeDatePicker from "shared/components/rangeDatePicker";
import useWindowSize from "shared/customHooks/windowSize";
import { headers_enums, pending_transactions } from "./constants";
import { useNavigate, useParams } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";
import PendingTransactions from "./pendingTransactions";

function AdminPendingTasks() {
  const params = useParams();
  const navigate = useNavigate();
  const screenWidth = useWindowSize();
  const [activeTab, setActiveTab] = useState<any>(0);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [headers, setHeaders] = useState<any>(pending_transactions);
  const [activePage, setActivePage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");

  const tabs = [
    {
      value: 0,
      label: "Pending Transactions",
      counter: 5,
      tabs_enum: "pending_transactions",
    },
  ];

  const handleChange = (event: any, newValue: number) => {
    setActiveTab(newValue);

    let filteredTab: any = tabs.findIndex((item) => item?.value === newValue);

    if (filteredTab > -1) {
      navigate(
        routeConstant.pendingTasks.path
          .replace(":keyword", "accountant")
          .replace(":task", tabs[filteredTab]?.tabs_enum)
      );
    }

    if (newValue === headers_enums.pending_transactions) {
      setHeaders(pending_transactions);
    }
  };

  useEffect(() => {
    let filteredTab: any = tabs.findIndex(
      (item) => item?.tabs_enum === params?.task
    );

    if (filteredTab > -1) {
      handleChange("", tabs[filteredTab]?.value);
    }

    // eslint-disable-next-line
  }, [params?.task]);

  return (
    <div>
      <div className={styles.topLevelContainer}>
        <div className={styles.headingContainer}>
          <label className={styles.heading}>Pending Task of Accountant</label>
          <label className={styles.subHeading}>
            Table with pending task tabs, list and actions to perform.
          </label>
        </div>
        <div className={styles.rangePicker}>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            doubleLabel={true}
          />
        </div>
      </div>

      <div className={styles.mainContainer}>
        <Box className={styles.boxContainer}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            className={styles.tab}
            TabIndicatorProps={{
              style: {
                backgroundColor: "black",
              },
            }}
          >
            {tabs?.map((item: any, index: any) => {
              return (
                <Tab
                  label={
                    <div
                      className={classNames(
                        styles.tabs,
                        activeTab === item?.value && styles.active
                      )}
                    >
                      <label className={styles.tabLabel}> {item?.label}</label>
                      <label className={styles.tabCounter}>
                        {item?.counter}
                      </label>
                    </div>
                  }
                />
              );
            })}
          </Tabs>
        </Box>
        <Box className={styles.toptableContainer}>
          <div className={styles.headingContainer}>
            {activeTab === headers_enums.pending_transactions ? (
              <>
                <label className={styles.tableHeading}>
                  Pending Transaction
                </label>
              </>
            ) : (
              " "
            )}
          </div>
          <div className={styles.gridContainer}>
            <Icons.SearchIcon className={styles.searchIcon} />
            <input
              placeholder="Search"
              className={styles.input}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </Box>

        <TableContainer
          component={Paper}
          className={styles.tableContainer}
          sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
          id="table-view-dashboard"
        >
          <Table aria-label="simple table">
            <TableHead className={styles.tableHead}>
              <TableRow>
                {headers?.map((item: any) => {
                  return (
                    <>
                      <TableCell>{item}</TableCell>
                    </>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {activeTab === headers_enums.pending_transactions ? (
                <PendingTransactions />
              ) : (
                <></>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <PaginationComponent
          totalPages={"1"}
          activePage={activePage}
          setActivePage={setActivePage}
        />
      </div>
    </div>
  );
}

export default AdminPendingTasks;
